export const QA_NAME_POST_FOOTER_ACTION_CONTEXT = 'footerAction'
